<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div ref="dynamicDialog" class="modal" style="max-width: fit-content; min-width: 85%;">
            <div class="modal__header">
                <h2 class="headline-s">Shipping Dimensions</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body">
                <div class="modal__body--content-wrapper" style="width:100%;">
                    <rothco-table style="height: 400px; overflow: auto;" v-model:content="gridData" :visible-fields="columnHeaders">
                        <template v-for="(item, index) in gridData" :key="`variant_${index}`" v-slot:[`variant_${index}`]="slotProps">
                            <div class="badge-wrapper">
                                <p v-if="dynamicHeaders.length === 0" class="paragraph-default badge" style="visibility: hidden">No Variants</p>
                                <p v-for="(variantValue,i) in (specGroups)" :key="i" class="paragraph-default badge">{{ item?.data[variantValue] }}</p>
                            </div>
                        </template> 
                    </rothco-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { inject, ref, computed } from "vue";
    import { onClickOutside } from "@vueuse/core";
    import RothcoTable from "@/components/RothcoTable.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    const dialogRef = inject('dialogRef');
    let dynamicDialog = ref();

    let shippingDimensions = dialogRef?.value?.data?.shipping_dimensions ?? null;
    let specGroups = dialogRef?.value?.data?.spec_groups ?? null;

    let dynamicHeaders = computed(()=>{
        return specGroups.map(group=>{
            return {field: group, is_custom: false, show_only: 'desktop', label: String(group).charAt(0).toUpperCase() + String(group).slice(1)};
        });
    });

    let columnHeaders = computed(()=>{
        return [
            ...dynamicHeaders.value, 
            {
                field: 'variant',
                is_custom: true,
                label: 'Variation',
                show_only: "mobile",
                pt: {
                    bodyCell: {class: 'mob-w-75', 'data-label': "Variation"}
                },
            },
            {
                field: 'length',
                is_custom: false, 
                label: 'Length (IN)',
                pt: {
                    bodyCell: {class: 'mob-w-25', 'data-label': 'Length'}
                }
            },
            {
                field: 'width',
                is_custom: false, 
                label: 'Width (IN)',
                pt: {
                    bodyCell: {class: 'mob-w-25', 'data-label': 'Width'}
                }
            },
            {
                field: 'height', 
                is_custom: false, 
                label: 'Height (IN)',
                pt: {
                    bodyCell: {class: 'mob-w-25', 'data-label': 'Height'}
                },
            },
            {
                field: 'volume', 
                is_custom: false, 
                label: 'Volume (Cubic IN)',
                pt: {
                    bodyCell: {class: 'mob-w-25', 'data-label': 'Volume'}
                },
            },
            {
                field: 'weight', 
                is_custom: false, 
                label: 'Weight (LB)',
                pt: {
                    bodyCell: {class: 'mob-w-25', 'data-label': 'Weight'}
                },
            }
        ];
    });

    let gridData = computed(()=>{
        return shippingDimensions.map(dim=>{
            return {data: dim}
        });
    });

    const closeDialog = () => {
        dialogRef?.value?.close();
    };
    onClickOutside(dynamicDialog, ()=>{
        closeDialog();
    });
</script>